import { graphql } from '../graphql/generated';

export const SPLIT_REQUEST_MUTATION = graphql(`
  mutation SplitRequest($requestId: ID!) {
    splitRequest(requestId: $requestId) {
      id
    }
  }
`);
